import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';

interface DropdownOption {
  id: string;
  name: string;
}

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

interface DropdownParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const assetDisposalApi = createApi({
  reducerPath: 'assetDisposalApi',
  baseQuery: createExtendedTokenBaseQuery(''),
  tagTypes: ['DisposalReasons', 'DisposalStatuses'],
  keepUnusedDataFor: 120,
  endpoints: (builder) => ({
    getDisposalReasonsDropdown: builder.query<PaginatedResponse<DropdownOption>, DropdownParams>({
      query: (params = {}) => {
        const queryParams: Record<string, string | number> = {};
        if (params.search) {
          queryParams['search'] = params.search;
        }
        if (params.page) {
          queryParams['page'] = params.page;
        }
        if (params.limit) {
          queryParams['limit'] = params.limit;
        }
        return {
          url: 'assets/disposals/reasons/dropdown/',
          method: 'GET',
          params: queryParams,
        };
      },
      providesTags: ['DisposalReasons'],
    }),
    getDisposalStatusesDropdown: builder.query<PaginatedResponse<DropdownOption>, DropdownParams>({
      query: (params = {}) => {
        const queryParams: Record<string, string | number> = {};
        if (params.search) {
          queryParams['search'] = params.search;
        }
        if (params.page) {
          queryParams['page'] = params.page;
        }
        if (params.limit) {
          queryParams['limit'] = params.limit;
        }
        return {
          url: 'assets/disposals/statuses/dropdown/',
          method: 'GET',
          params: queryParams,
        };
      },
      providesTags: ['DisposalStatuses'],
    }),
  }),
});

export const {
  useGetDisposalReasonsDropdownQuery,
  useGetDisposalStatusesDropdownQuery,
} = assetDisposalApi;